<template>
  <Modal transfer width="900" :title="distriServeTitle" class="select-spare" v-model="isShow" @on-ok="submit">
    <div class="content">
      <div class="right">
        <div class="selectTag" v-if="attached">
          <span style="line-height:24px;">标签:</span>
          <Tag
            style="margin-left:10px;"
            type="border"
            v-for="(item, index) in checkList"
            :key="index"
            closable
            @on-close="checkList.splice(index, 1)"
          >
            {{ item.name }}
          </Tag>
        </div>
        <!-- 工单列表 -->
        <div class="table">
          <Table
            stripe
            ref="table"
            :loading="listLoading"
            :columns="columns"
            :data="orderList"
            @on-select="onSelect"
            @on-select-cancel="onSelectCancel"
            @on-select-all="selectAll"
            @on-select-all-cancel="selectAllCancel"
          />
        </div>
        <Page
          show-total
          show-sizer
          class="page"
          placement="top"
          :current="pageIndex + 1"
          :total="orderCount"
          @on-change="pageIndexChange"
          @on-page-size-change="pageSizeChange"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    attached: {
      type: Boolean,
      default: false
    },
    sparepart: Object, // 备件使用
		distriServeTitle: String
  },
  data() {
    return {
      checkList: [],
      isShow: this.value,
      listLoading: false, // 表格加载状态
      selection: [],
      orderList: [],
      orderCount: 0,
      pageSize: 10,
      pageIndex: 0,
      typeId: -1
    }
  },
  watch: {
    value(val) {
      this.isShow = val
      if (val) {
        this.loadList()
				this.checkList = []
      }
    },
    isShow(val) {
      this.$emit('input', val)
      if (!val) {
        this.selection = []
        this.typeId = -1
      }
    },
    typeId(val) {
      this.pageIndex = 0
      this.loadList()
    },
    checkList: {
      handler(v) {
        this.setCheck()
      },
      deep: true
    },
    sparepart: {
      handler(v) {
        let arr = []
        if (v.labelIdName) {
					let a = v.labelIdName
					let b = a.split(',')
					b.forEach(v => {
						if (v) {
							let c = v.split('-')
							let d = {
								id: Number(c[0]),
								name: c[1]
							}
							arr.push(d)
						}
					})
          this.checkList = arr
          this.setCheck()
        }
      },
      immediate: true
    }
  },
  computed: {
    columns() {
      const allColumns = [
        {
          type: 'selection',
          width: 60
        },
        {
          title: '标签名称',
          key: 'name',
          width: 180
        },
        {
          title: '创建时间',
          key: 'create_time',
          ellipsis: true
        },
        {
          title: '创建人',
          key: 'create_user_name'
        }
      ]
      return allColumns
    }
  },
  created() {
  },
  methods: {
    setCheck() {
      let ids = this.checkList.map(v => v.id)
      this.orderList.forEach((v, i) => {
        if (ids.includes(v.id)) {
          v._checked = true
        } else {
          v._checked = false
        }
        this.$set(this.orderList, i, v)
      })
    },
    onSelect(list, row) {
      this.checkList.push(row)
    },
    selectAll(list) {
      list.forEach(v => {
        if (!this.checkList.find(list => list.id === v.id)) {
          this.checkList.push(v)
        }
      })
    },
    selectAllCancel() {
      this.orderList.forEach(v => {
        let index = this.checkList.findIndex(list => list.id === v.id)
        if (index !== undefined) {
          this.checkList.splice(index, 1)
        }
      })
    },
    onSelectCancel(list, row) {
      let index = this.checkList.findIndex(v => v.id === row.id)
      this.checkList.splice(index, 1)
    },
    checkItem(list) {
      let filterList = list.filter(element => {
        let ids = this.selection.map(v => v.id)
        return !ids.includes(element.id)
      })
      this.selection = this.selection.concat(filterList)
    },
    submit() {
      if (!this.attached) {
        this.isShow = false
      } else {
        this.$emit('on-success', this.checkList)
      }
    },
    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.$http
        .all([
          this.$http.get('/label/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize
            }
          }),
          this.$http.get('/label/count', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize
            }
          })
        ])
        .then(
          this.$http.spread((res1, res2) => {
            if (res1.success) {
              this.orderList = res1.data
            }
            if (res1.success) this.orderCount = res2.data
            this.listLoading = false
            this.setCheck()
          })
        )
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    }
  }
}
</script>

<style lang="less" scoped>
.selectTag {
  margin-bottom: 20px;
}
.top {
  min-height: 43px;
  line-height: 43px;
  padding: 0 20px;
  border-bottom: 1px solid #dddee1;
}
.content {
  display: flex;
  height: 100%;
  flex: 1;

  .left {
    width: 285px;
    border-right: 1px solid #dddee1;
    padding: 10px;
  }

  .right {
    width: 100%;
    margin: 20px 16px 20px;
    overflow: hidden;

    .search {
      width: 300px;
      margin-bottom: 20px;
    }

    .table {
      margin-bottom: 20px;
    }
  }
}
</style>
<style media="screen">
.select-spare .ivu-modal-content .ivu-modal-body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/AllLable1.vue